// An audit entry's diff in words: each field as before → after (or what it was set to), never JSON.

export type DiffRow = { label: string; before?: string; after: string };

const human = (k: string) => k.replace(/_/g, ' ').replace(/^./, (c) => c.toUpperCase());
const isObj = (v: unknown): v is Record<string, unknown> => Boolean(v) && typeof v === 'object' && !Array.isArray(v);

/** A value as a person reads it: lists joined, yes/no, nested fields as "Field: value". */
export function valueWords(v: unknown): string {
  if (v === null || v === undefined || v === '') return 'nothing';
  if (typeof v === 'boolean') return v ? 'yes' : 'no';
  if (typeof v === 'number') return v.toLocaleString('en-US');
  if (Array.isArray(v)) return v.length ? v.map(valueWords).join(', ') : 'none';
  if (isObj(v)) return Object.entries(v).map(([k, x]) => `${human(k)}: ${valueWords(x)}`).join('; ');
  return String(v).replace(/_/g, ' ');
}

export function diffWords(diff: unknown): DiffRow[] {
  if (!isObj(diff)) return diff === null || diff === undefined ? [] : [{ label: 'Details', after: valueWords(diff) }];
  const rows: DiffRow[] = [];
  const { before, after, from, to, ...rest } = diff as Record<string, unknown>;
  if (isObj(before) || isObj(after)) {
    const b = isObj(before) ? before : {}; const a = isObj(after) ? after : {};
    for (const k of new Set([...Object.keys(b), ...Object.keys(a)])) rows.push({ label: human(k), before: valueWords(b[k]), after: valueWords(a[k]) });
  } else if (from !== undefined || to !== undefined) rows.push({ label: 'Changed', before: valueWords(from), after: valueWords(to) });
  else if (before !== undefined || after !== undefined) rows.push({ label: 'Changed', before: valueWords(before), after: valueWords(after) });
  for (const [k, v] of Object.entries(rest)) {
    if (isObj(v) && ('from' in v || 'to' in v)) rows.push({ label: human(k), before: valueWords(v.from), after: valueWords(v.to) });
    else rows.push({ label: human(k), after: valueWords(v) });
  }
  return rows;
}
